export default function () {
  if (herald_js_settings.header_ad_responsive) {
    var header_ad = $('#header .herald-ad');
    if ($(window).width() < herald_js_settings.header_responsive_breakpoint && !header_ad.hasClass('cloned')) {
      header_ad.addClass('cloned');
      var responsive_ad = header_ad.clone().removeClass('cloned hidden-xs').addClass('header-mobile-ad');
      responsive_ad.insertAfter('#herald-responsive-header');
    }
  }
}
